import React , { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button, SimpleForm, DateInput, AutocompleteArrayInput, SelectArrayInput, SelectInput, ReferenceArrayInput, Toolbar, useNotify,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, BooleanInput, SaveButton, required, FormDataConsumer
} from 'react-admin';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import EditIcon from '@material-ui/icons/Edit';
import CopyIcon from '@material-ui/icons/FileCopy';
import CloudDownload from '@material-ui/icons/CloudDownload';
import DataTable from 'react-data-table-component';
import { fetchUtils } from 'react-admin';
import authProvider from './authProvider';

const choicesBrowser = require('./components/browsers.json');
const choicesAdType = require('./components/adtypes.json');
const choicesSizes = require('./components/sizes.json');
const countryChoices = require('./components/countries.json');
const choicesDevices = require('./components/devices.json');
const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const fetch = fetchUtils.fetchJson;


const BASE_URL = window.nobid_endpoint+'/adquality_reports_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  let keys = Object.keys(array[0]);
  keys = keys.filter(key => (key!=='code' && key!=='adx_ad_requests' && key!=='id'));

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (key==='code' || key==='adx_ad_requests' || key==='id') return;
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function downloadCSV(array) {
  array.forEach((row, i) => {
    delete array[i].id
    delete array[i].code
    if (array[i].ad_domains) array[i].ad_domains = JSON.parse(array[i].ad_domains);
  })
  dataSupport.exportData(array)
}

const types = {
  blocked_request: 'Blocked Requests',
  bid_request: 'Bid Requests',
  ad_request: 'Ad Requests',
  bid_response: 'Bid Responses',
};

const choicesInterval = [
    { id: 'day', name: 'Daily' },
    { id: 'week', name: 'Weekly' },
    { id: 'month', name: 'Monthly' },
    { id: 'year', name: 'Yearly' }
];
const choicesShowAdmin = [
    { id: 'date', name: 'Date' },
    { id: 'type', name: 'Type' },
    { id: 'publisher', name: 'Publisher' },
    { id: 'site', name: 'Site' },
    { id: 'tldomain', name: 'Domain/App' },
    { id: 'bidder', name: 'Bidder' },
    { id: 'country', name: 'Country' },
    { id: 'device', name: 'Device' },
    { id: 'adsize', name: 'Ad Size' },
    { id: 'ad_type', name: 'Ad Type' },
    { id: 'browser', name: 'Browser' },
    { id: 'rejection', name: 'Rejection Reason' },
    { id: 'creative_id', name: 'Creative ID' },
    { id: 'ad_domains', name: 'Advertiser Domains' },
    { id: 'ad_categories', name: 'Advertiser Categories' },
    { id: 'ad_attributes', name: 'Creative Attibutes' },
    { id: 'bid_prices', name: '$Bid Prices' },
    { id: 'avg_price', name: '$Avg Bid' },
    { id: 'avg_floor', name: '$Avg Floor' },
];

function choicesShow (permissions) {
  if (!permissions) return []
  if ( ['admin', 'report_admin'].includes(permissions.role)) {
    return choicesShowAdmin;
  } else if (permissions.role === 'publisher') {
    return choicesShowAdmin.filter(x => !['bidder', 'creative_id', 'tldomain', 'type'].includes(x.id));
  }
  return [];
}
function choicesType (permissions) {
  return [
    {id: 'blocked_request', name: 'Blocked Requests' },
    {id: 'bid_request', name: 'Bid Requests' },
    {id: 'ad_request', name: 'Ad Requests'},
    {id: 'bid_response', name: 'Bid Responses'}
  ];
}
function showAdvertiserDomains (adomains) {
  const domains = JSON.parse(adomains);
  let search = '';
  let label = '';
  let copy = '';
  if (domains && domains.length>0) {
    search = domains.join('%7C');
    label = domains.join(', ');
    copy = domains.join('|');
  }
  if (search) {
    const href = `/#/advertiser_domains?filter=%7B"search_name"%3A"${search}"%7D`;
    const ret = <div style={{width: '100%', height: '-webkit-fill-available', overflow: 'scroll'}} >{label}</div>;
    // if (!role || role!=='publisher') {
    //   ret.unshift(<Button label='COPY' onClick={() => {navigator.clipboard.writeText(copy)}} props={this} variant='contained' color='primary' startIcon={<CopyIcon />} target='_blank' style={{marginRight: '5px'}}/>);  
    //   ret.unshift(<Button label='EDIT' href={href} props={this} variant='contained' color='primary' startIcon={<EditIcon />} target='_blank' style={{marginRight: '5px'}}/>);
    // }
    return ret;
  } else {
    return '';
  }
}

function showList (list) {
  let label = '';
  const jlist = JSON.parse(list);
  if (jlist && jlist.length>0) {
    if (Array.isArray(jlist)) label = jlist.join(', ');
    else label=jlist;
  }
  return <div style={{width: '100%', height: '-webkit-fill-available', overflow: 'scroll'}} >{label}</div>;
}

function showType (type) {
  if (types[type]) return types[type];
  return type;
}

let BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true, cell: row => row.date },
  { name: 'Type', selector: 'type', sortable: true, cell: row => showType(row.type) },
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: 'Site', selector: 'site_name', sortable: true },
  { name: 'Site ID', selector: 'site_id', sortable: true },
  { name: 'Domain/App', selector: 'tldomain', sortable: true },
  { name: 'Bidder', selector: 'bidder_name', sortable: true },
  { name: 'Country', selector: 'country', sortable: true },
  { name: 'Device', selector: 'device', sortable: true },
  { name: 'Ad Size', selector: 'adsize', sortable: true },
  { name: 'Ad Type', selector: 'ad_type', sortable: true },
  { name: 'Browser', selector: 'browser', sortable: true },
  { name: 'Rejection', selector: 'rejection_name', sortable: true },
  { name: 'Advertisers', selector: 'ad_domains', sortable: true, cell: row => showList(row.ad_domains) },
  { name: 'Categories', selector: 'ad_categories', sortable: true, cell: row => showList(row.ad_categories) },
  { name: 'Crative Attrs', selector: 'ad_attributes', sortable: true },
  { name: 'Creative ID', selector: 'creative_id', sortable: true },
  { name: 'Total', selector: 'total_count', sortable: true, cell: row => <span>{ utils.formatLong(row.total_count) }</span> },
  { name: '$Bid Prices', selector: 'bid_prices', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_prices) }</span> },
  { name: '$Avg Bid', selector: 'avg_price', sortable: true, cell: row => <span>{ utils.formatDouble(row.avg_price) }</span> },
  { name: '$Avg Floor', selector: 'avg_floor', sortable: true, cell: row => <span>{ utils.formatDouble(row.avg_floor) }</span> },
];

// const defaultColumnSelectors = ['bid_responses', 'bid_prices'];
const defaultColumnSelectors = ['total_count'];

const dateRangeChoices = [
  { id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];

let choicesRejectionReasons = [
  { id: '0', name: 'Accepted' },
  { id: '1', name: 'Invalid Price' },
  { id: '2', name: 'Missing ad markup' },
  { id: '3', name: 'Blocked advertiser domain'},
  { id: '4', name: 'Blocked advertiser category'},
  { id: '5', name: 'Blocked advertiser domain category'},
  { id: '6', name: 'Blocked creative attribute'},
  { id: '7', name: 'Blocked creative ID'},
  { id: '8', name: 'Price below floor'},
  { id: '50', name: 'Blocked by Auction Optimizer'},
  { id: '101', name: 'Bid Request error'},
  { id: '102', name: 'Bid Request execution error'}
];

const FORM_DATA_FIELDS = ['interval', 'date_range', 'start_date', 'end_date', 'publisher_id', 'site_id', 'bidder_id',
'rejection_id', 'ad_domains', 'type'];

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    authProvider.getPermissions().then(({role}) => {
      if (role==='publisher') choicesRejectionReasons = choicesRejectionReasons.filter(x => x.id !== '0' && x.id < 50);
    });
    super(props);
    this.parent = props.parent;
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      let total = 0;
      if (!Array.isArray(json) && json.data) {
        total = json.total || 0;
        json = json.data;
      }
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date && r.date.indexOf('T')>0) r.date = r.date.substring(0, r.date.indexOf('T'))
      }

      const showList = formData.show || [];
      const columnSelectors = defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`, `${x}_group`]));

      const columns = BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector));

      that.parent.setState({
        data: json,
        total: total,
        saved_data:json,
        columns: columns,
        loading: false});
    }

    formData.show = formData.show || [];
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}${utils.formDataFieldsQueryStringFormat(formData, FORM_DATA_FIELDS)}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading}/>
      </Toolbar>
    )
  }
}

const PubReportTitle = ({ record }) => {
  return <span>Ad Quality Report {record ? `"${record.name}"` : ''}</span>;
};

const PubReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

export const AdQualityReportsList = ({ permissions, ...props }) => (
  <List {...props} title="Ad Quality Reports" perPage={25} bulkActionButtons={false} filters={<PubReportFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

class ReportComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  render() {
    const { loading, data, total, dateRange } = this.state;
    const { permissions } = this.props;
    return (
      <div>
        <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: 'inherit', borderRadius: '5px' }} {...this.props}>
          <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
            <FormDataConsumer>
              {({ formData }) => setFormData(formData) }
            </FormDataConsumer>
            <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' 
              disabled={loading}/>
            <div>
              <SelectInput label="Date Range" source="date_range"
                onChange={value => this.setState({ dateRange: value.target.value })}
                choices={dateRangeChoices}
                defaultValue="mtd"
                disabled={loading} />
              <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
                <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
              </div>
					  </div>
            <SelectArrayInput label="Show" 
              source="show" 
              choices={choicesShow(permissions)}
              defaultValue={['rejection']}
              style={{ width: '100%', flexGrow: 1}}
              disabled={loading} />
          </div>
            
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
              <div style={{flex: 1}}>
                <ReferenceArrayInput 
                  source="publisher_id" 
                  label="Publisher" 
                  reference="publishers"
                  basePath="publishers"
                  perPage={15} 
                  sort={{ field: 'name', order: 'ASC' }}
                  filterToQuery={searchText => ({ search_name: searchText })}
                  allowEmpty
                  disabled={loading}>
                  <AutocompleteArrayInput disabled={loading}
                    label="Publishers"
                    optionText="name"
                    optionValue="code"
                    fullWidth/>
                </ReferenceArrayInput>
              </div>

              {permissions &&
                <div style={{flex: 1}}>
                  <ReferenceArrayInput 
                    source="site_id" 
                    label="Site" 
                    reference="sites"
                    basePath='sites'
                    perPage={15} 
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    allowEmpty
                    disabled={loading}>
                    <AutocompleteArrayInput disabled={loading} label="Sites" 
                      optionText={(permissions.role==='admin' || permissions.role==='report_admin')?"adunit_path":"name"}
                      optionValue="code"
                      fullWidth/>
                  </ReferenceArrayInput>
                </div>
              }
            
              {permissions && ['admin', 'report_admin'].includes(permissions.role) &&
                <div style={{flex: 1}}>
                  <ReferenceArrayInput 
                    source="bidder_id" 
                    label="Bidder" 
                    reference="bidders"
                    basePath='bidders'
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    allowEmpty
                    disabled={loading} >
                    <AutocompleteArrayInput label="Bidders" optionText={record => (record && record.name)?`${record.name} (${record.code})`:""}
                      optionValue="code" fullWidth/>
                  </ReferenceArrayInput>
                </div>
              }
              <div style={{flex: 1}}>
              <ReferenceArrayInput 
                source="ad_domains"
                label="Advertiser Domains" 
                reference="ad_domains_domains"
                basePath="ad_domains_domains"
                perPage={15}
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ search_name: searchText })}
                allowEmpty
                disabled={loading}
                >
                <AutocompleteArrayInput disabled={loading} 
                optionText={x => (x && x.code) ? `${x.name}` : ''}
                optionValue="id" fullWidth
                />
              </ReferenceArrayInput>
              </div>
              <div style={{flex: 1}}>
              <SelectArrayInput label="Rejection Reasons" 
              source="rejection_id" 
              choices={choicesRejectionReasons}
              style={{ flexGrow: 1}}
              disabled={loading} fullWidth/>
              </div>
            </div>

            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
              {permissions && ['admin', 'report_admin'].includes(permissions.role) &&
              <div style={{flex: 1}}>
                <SelectArrayInput label="Type" 
                  source="type"
                  choices={choicesType(permissions)}
                  style={{ width: '100%', flexGrow: 1}}
                  disabled={loading} />
              </div>
              }
              <div style={{flex: 1}}>
                <SelectArrayInput label="Countries"
                  source="country"
                  choices={countryChoices}
                  disabled={loading}
                  fullWidth/>
              </div>
              <div style={{flex: 1}}>
                <SelectArrayInput label="Devices" 
                  source="device" 
                  choices={choicesDevices} 
                  disabled={loading}
                  fullWidth />
              </div>
              <div style={{flex: 1}}>
                <SelectArrayInput label="Ad Sizes" 
                  source="adsize" 
                  choices={choicesSizes}
                  disabled={loading}
                  fullWidth />
              </div>
              
              <div style={{flex: 1}}>
                <SelectArrayInput label="Ad Type" 
                  source="ad_type" 
                  choices={choicesAdType}
                  disabled={loading}
                  fullWidth />
              </div>
              <div style={{flex: 1}}>
                <SelectArrayInput label="Browser" 
                  source="browser" 
                  choices={choicesBrowser}
                  disabled={loading}
                  fullWidth />
              </div>
            </div>

        </SimpleForm>
        <div style={{ height: '5px' }} />
        <div style={{ height: '5px' }} />
        <DataTable
          title="Ad Quality Report"
          theme={window.nobid_table_theme()}
          columns={this.state.columns}
          data={data}
          progressPending={loading}
          pagination
          fixedHeader
          paginationPerPage={30}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          dense
          highlightOnHover
          subHeader={!loading}
          subHeaderComponent={
            (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input type="text" id='search_box' label="Search" 
                variant="outlined" 
                style={{ margin: '5px' }} 
                onChange={(target) => dataSupport.filterData(this)}/>
                <CloudDownload 
                label="Export"
                style={{ margin: '5px' }} 
                color="action" 
                onClick={() => downloadCSV(this.state.data)}
                />
              </div>
            )
          }
        />
      </div>
    )
  }
};

export const AdQualityReportsEdit = (props) => (
  <Edit title={<PubReportTitle />}  {...props}>
    <ReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const AdQualityReportsCreate = (props) => (
  <Create title="Create Ad Quality Report" {...props}>
    <ReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
